module.exports = __webpack_public_path__ + "static/media/7-_DSC0732.bd8a8d6f.jpg";